import React from 'react';
import { SessionProvider } from 'components/sessions/context/SessionContext';
import SessionForm from 'components/sessions/jsx/SessionForm';
import SessionList from 'components/sessions/jsx/SessionList';
import SessionProfitChart from 'components/sessions/jsx/SessionProfitChart';

const Session = ({ user }) => {
  if (!user) {
    return <p>Authenticating...</p>;
  }

  return (
    <SessionProvider user={user}>
      <div>
        <SessionForm />
        <SessionProfitChart />
        <SessionList />
      </div>
    </SessionProvider>
  );
};

export default Session;
